export enum Generation {
  BabyBoomer = 'baby_boomer',
  GenerationX = 'generation_x',
  GenerationY = 'generation_y',
  GenerationZ = 'generation_z',
  GenerationAlpha = 'generation_alpha',
}
